import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { DrawdownInvestmentStrategyClient } from "../../../../../../Wrap/Api/Account/DrawdownInvestmentStrategy";
import { PersonalDetailClient } from "../../../../../../Wrap/Api/Customer/PersonalDetail";
import { BatchClient } from "../../../../../../Wrap/Api/Orders/Batch";
import { BuySellClient } from "../../../../../../Wrap/Api/Orders/BuySell";
import { OrdersClient } from "../../../../../../Wrap/Api/Orders/Orders";
import { ClientTradableInvestmentClient } from "../../../../../../Wrap/Api/PortfolioAnalysis/Investment/ClientTradableInvestment";
import { OrderDirection } from "../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { BatchInfoModel } from "../../../../../../Wrap/Models/Domains/Orders/Batch/BatchInfoModel";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { BuyDispatcher } from "../Store/Variable";

export class BuyAction {
    public static initBuyModel() {
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const initModel = {
            BatchType: BatchType.OneOff,
            OrderType: BatchType.OneOff,
            ActionDate: JsonDateParser.toJsonDateNoOffset(new Date()),
            HierarchyId: subAccountHierarchyId,
            InvestmentList: [],
            InvestmentPathwayAnswers: { PersonalRecommendation: true}
        };
        BuyDispatcher.dispatch({ actionType: ActionType.Success, payload: initModel });
    }

    public static goToNextStep(from, data, callback) {
        if (from == 0) {
            return this.getBatchId(data, callback);
        } else if (from == 1) {
            return this.saveInvestmentSelection(data, callback);
        }
        callback();
    }

    public static saveInvestmentSelection(data, callback) {
        this.RoundInvestmentValues(data);

        const client = new BuySellClient();
        data.BuyOrSell = OrderDirection.Buy;
        client.post(data).onSuccess((d) => {
            callback(d);
        });
    }
    
    private static RoundInvestmentValues(data) {
        const totalPercentage = data.InvestmentList.reduce(
            (sum, curr) => (sum = sum + (curr.OrderPercentage ? curr.OrderPercentage : 0)),
            0
        );

        if (totalPercentage != 100) {
            return;
        }

        const totalExpectedValue = data.TotalValue;
        let totalCurrentValue = 0;

        data.InvestmentList.forEach((ele) => {
            if (ele.OrderValue != null) {
                ele.OrderValue = Number(ele.OrderValue.toFixed(2));
                totalCurrentValue += ele.OrderValue;
            }           
        });

        const difference = totalCurrentValue - totalExpectedValue;

        if (totalExpectedValue > 0 && difference != 0) {
            const highestValueOrder = data.InvestmentList.reduce((prev, current) => (prev && prev.OrderValue > current.OrderValue) ? prev : current);
            highestValueOrder.OrderValue = Number((highestValueOrder.OrderValue - difference).toFixed(2));
        }
    }

    public static savePensionInvestmentPath(data, callback?) {
        const subaccountid = getQueryParameters()["subaccounthierarchyid"];
        const client = new DrawdownInvestmentStrategyClient();
        let promise = client.post(subaccountid, data.InvestmentPathwayAnswers);
        promise.onSuccess((result) => {
            if(callback) callback(result)
        });
        promise.onError((err) => {
            if(callback) callback(err)
        });
    }

    public static getBatchInfo(data: BatchInfoModel, onSuccess: (data: BatchInfoModel) => void, onError?: (error: any) => void) {
        let promise;
        const client = new BuySellClient();
        data.BuyOrSell = OrderDirection.Buy;
        promise = client.put(data);
        promise.onSuccess((result) => {
            onSuccess?.(result);
        });

        promise.onError((err) => {
            onError?.(err);
        });
    }

    public static getBatchId(data, callback) {
        const batchId = getQueryParameters()["batchId"];
        if (batchId) {
            BuyDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback([]);}
            return data;
        }

        let promise;
        const client = new BatchClient();
        promise = client.post(data);
        promise.onSuccess((result) => {
            const payload = {
                ...result,
                OrderType: data.OrderType,
                InvestmentList: data.InvestmentList || [],
                TotalValue: data.TotalValue || [],
                AdviceGiven: true,
                InvestmentPathwayAnswers: { PersonalRecommendation: true }
            };

            BuyDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: payload,
            });

            if (callback) { callback(payload); }
        });

        promise.onError((err) => { });
    }

    public static submit(data, callback) {
        const client = new OrdersClient();
        client.post(data).onSuccess((result) => {
            callback(result);
        });
    }

    public static getReuseHoldings(hierarchyId, subHierarchyId, batchId, callback) {
        const client = new ClientTradableInvestmentClient();
        const promise = client.get(hierarchyId, subHierarchyId, batchId, false).onSuccess((result) => {
            callback(result);
        });
    }

    public static getReuseHoldingsExcludeAdj(hierarchyId, subHierarchyId, batchId, callback) {
        const client = new ClientTradableInvestmentClient();
        const promise = client.get(hierarchyId, subHierarchyId, batchId, true).onSuccess((result) => {
            callback(result);
        });
    }
}
